import React from 'react';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import {
  FormGroup,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Checkbox,
  FormControlLabel,
  Typography
} from '@material-ui/core';
import { inputParam, defaultParam, ParamLabel } from 'common/Constants';

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    top: '50%',
    left: '50%'
  },
  textField: {
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4)
  },
  Button: {
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(3)
  },
  description: {
    minHeight: 30,
    maxHeight: 100,
    overflowY: 'scroll',
    marginLeft: theme.spacing(4),
    marginRight: theme.spacing(4)
  },
  labelRoot: {
    fontSize: 16,
    margin: 'dense',
    color: 'black'
  },
  form: {
    maxHeight: 450,
    overflowY: 'scroll'
  }
}));

const InputDialog = ({
  onClose,
  open,
  title,
  engine,
  phase,
  input,
  phaseInput,
  setPhaseInput,
  parentCallback,
  setPhaseParameter
}) => {
  //console.log(input);
  const description = phase.description;
  const handleClose = () => {
    //console.log("handle close")
    parentCallback(undefined);
    onClose();
  };
  const handleChangeValue = param => event => {
    var newState = { ...phaseInput, [param]: event.target.value };
    setPhaseInput(newState);
    setPhaseParameter(engine, param, event.target.value);
    //console.log(newState)

    //handleMutationInput(param,event.target.value);
  };

  const Display = param => {
    if (!inputParam.includes(param)) {
      return (
        <TextField
          className={classes.textField}
          key={param}
          id={param}
          required={true}
          color="secondary"
          label={ParamLabel[param] !== undefined ? ParamLabel[param] : param}
          InputLabelProps={{
            classes: {
              root: classes.labelRoot
            }
          }}
          variant="outlined"
          size="small"
          onChange={handleChangeValue(param)}
          value={phaseInput[param]}
        />
      );
    }
  };

  const classes = useStyles();
  return (
    <Dialog
      className={classes.root}
      aria-labelledby="input-dialog"
      open={open}
      fullWidth={true}
      maxWidth="sm">
      <DialogTitle id="input-dialog" align="center">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.description}>
          {description.substring(
            0,
            description.indexOf('*#*#') === -1
              ? description.length
              : description.indexOf('*#*#')
          )}
        </DialogContentText>
        <FormGroup className={classes.form} id={input}>
          {input.map(param => Display(param))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button
          className={classes.Button}
          color="secondary"
          size="medium"
          variant="outlined"
          onClick={handleClose}>
          {' '}
          Ok{' '}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

InputDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  phase: PropTypes.object.isRequired
};
var initialPhaseInput = {};

const PhaseStage = ({
  engine,
  alternatePhase,
  selectedPhase,
  parentCallback,
  setPhaseParameter,
  phaseIdMap,
  alternatePhaseIdMap
}) => {
  const phase = selectedPhase;
  //console.log(phase);
  const phaseId = phase.id;
  const [status, setStatus] = React.useState(false);
  const phaseName = phase.name;
  //const [changeStatus]=useMutation(EDIT_PHASE);
  const [modalInput, setModalInput] = React.useState(false);
  if (initialPhaseInput[engine] === undefined) {
    initialPhaseInput[engine] = {};
  }
  phase.cypherQuery.match(/\$[0-9a-zA-Z]+/g).map(x => {
    const keyName = x.substring(1);
    //initialPhaseInput[engine][keyName]="10"
    if (initialPhaseInput[engine][keyName] === undefined) {
      if (!inputParam.includes(keyName)) {
        if (keyName in defaultParam) {
          initialPhaseInput[engine][keyName] = defaultParam[keyName];
          setPhaseParameter(engine, keyName, defaultParam[keyName]);
        } else {
          initialPhaseInput[engine][keyName] = '10';
          setPhaseParameter(engine, keyName, '10');
        }
      }
    }
  });
  const [phaseInput, setPhaseInput] = React.useState(initialPhaseInput[engine]);
  const handleChange = phase => {
    parentCallback(undefined);
    setStatus(!status);
    // changeStatus({
    //     variables: {
    //     id: phase.id,
    //     input: { active: !status}
    //     }
    // })
    phaseIdMap[`"${phase.id}"`] = !status;
    if (alternatePhase !== undefined) {
      alternatePhaseIdMap[`"${alternatePhase.id}"`] = !status;
      //   changeStatus({
      //     variables: {
      //     id: alternatePhase.id,
      //     input: { active: !status}
      //     }
      // })
    }
  };
  const handleOpen = () => setModalInput(true);
  const handleClose = () => setModalInput(false);
  var input = phase.cypherQuery
    .match(/\$[0-9a-zA-Z]+/g)
    .map(x => x.substring(1));
  return (
    <div key={phaseId}>
      <IconButton onClick={handleOpen}>
        <EditIcon
          size="small"
          variant="contained"
          color="secondary"
          edge="end"
        />
      </IconButton>
      <FormControlLabel
        size="small"
        control={
          <Checkbox
            checked={status}
            onChange={() => {
              handleChange(phase);
              if (!status) {
                handleOpen();
              }
            }}
          />
        }
        label={<Typography style={{ fontSize: 18 }}>{phase.name}</Typography>}
      />
      <InputDialog
        open={modalInput}
        input={input}
        title={phaseName}
        engine={engine}
        phase={phase}
        onClose={handleClose}
        phaseInput={phaseInput}
        setPhaseInput={setPhaseInput}
        parentCallback={parentCallback}
        setPhaseParameter={setPhaseParameter}
      />
    </div>
  );
};

PhaseStage.propTypes = {
  selectedPhase: PropTypes.object.isRequired
};

export default PhaseStage;
